import * as React from 'react'

import { TributeComponentParams } from './types'

export interface TributeComponentWrapperProps extends TributeComponentParams {}

export const TributeComponentWrapper: React.FC<TributeComponentWrapperProps> = (props) => {
	const { children } = props
	const id = props.domId || ''
	const organization = props.organization || ''
	const ppm = props.ppm || ''
	const title = props.title || ''
	const type = props.type || ''
	const wbsComponent = props.wbsComponent || ''
	const workItem = props.workItem || ''

	return (
		<span
			className='fr-deletable fr-tribute schedio-tribute-component'
			contentEditable={false}
			id={id}
			data-tribute-title={title}
			data-tribute-type={type}
			data-tribute-organization={organization}
			data-tribute-ppm={ppm}
			data-tribute-wbscomponent={wbsComponent}
			data-tribute-workitem={workItem}
		>
			{children}
		</span>
	)
}
